import React, { forwardRef, memo } from 'react'

const CalendarIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="34.3"
      height="33.6"
      viewBox="0 0 34.3 33.6"
      fill="none"
      {...props}>
      <g
        stroke="currentColor"
        strokeWidth="2.259"
        strokeLinecap="round"
        strokeLinejoin="round">
        <path d="M27.806 5.25h-21c-.58 0-1.05.47-1.05 1.05v21c0 .58.47 1.05 1.05 1.05h21c.58 0 1.05-.47 1.05-1.05v-21c0-.58-.47-1.05-1.05-1.05Z" />
        <path d="M23.606 3.15v4.2M11.006 3.15v4.2M5.756 11.55h23.1" />
      </g>
      <circle cx="17.306" cy="17.324" r="1.576" fill="currentColor" />
      <circle cx="23.082" cy="17.324" r="1.576" fill="currentColor" />
      <circle cx="11.531" cy="22.574" r="1.576" fill="currentColor" />
      <circle cx="17.306" cy="22.574" r="1.576" fill="currentColor" />
      <circle cx="23.082" cy="22.574" r="1.576" fill="currentColor" />
    </svg>
  )
)

CalendarIcon.displayName = 'CalendarIcon'

export default memo(CalendarIcon)
